/**
 * Created by AlexanderC on 5/25/15.
 */

'use strict';

/* eslint no-proto:0 */

/**
 * Fixes babel@6 issue: https://phabricator.babeljs.io/T3083
 * @param {*} errorClass
 * @returns {ExtendableClass}
 * @constructor
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Extendable(errorClass) {

  /**
   * @constructor
   */
  function ExtendableClass() {
    errorClass.apply(this, arguments);
  }

  ExtendableClass.prototype = Object.create(errorClass.prototype);
  Object.setPrototypeOf ? Object.setPrototypeOf(ExtendableClass, errorClass) : ExtendableClass.__proto__ = errorClass;

  return ExtendableClass;
}

/**
 * Base exception
 */

let Exception = exports.Exception = function (_Extendable) {
  _inherits(Exception, _Extendable);

  _createClass(Exception, null, [{
    key: 'CODE_KEY',

    /**
     * @returns {String}
     */
    get: function get() {
      return '_deep_error_code_';
    }

    /**
     * @returns {Number}
     */

  }, {
    key: 'DEFAULT_CODE',
    get: function get() {
      return 400;
    }

    /**
     * @param {String} message
     * @param {Number} code
     */

  }]);

  function Exception(message) {
    let code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Exception.DEFAULT_CODE;

    _classCallCheck(this, Exception);

    var _this = _possibleConstructorReturn(this, (Exception.__proto__ || Object.getPrototypeOf(Exception)).call(this));

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      Object.defineProperty(_this, 'stack', {
        value: new Error().stack
      });
    }

    Object.defineProperty(_this, 'message', {
      value: message
    });

    // It's used to map error codes to API Gateway http status codes
    _this._code = code;
    return _this;
  }

  /**
   * @returns {String}
   */


  _createClass(Exception, [{
    key: 'name',
    get: function get() {
      return this.constructor.name;
    }

    /**
     * @param {Number} code
     */

  }, {
    key: 'code',
    set: function set(code) {
      this._code = code;
    }

    /**
     * @returns {Number}
     */
    ,
    get: function get() {
      return this._code;
    }
  }]);

  return Exception;
}(Extendable(Error));


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/Exception/Exception.js
// module id = 16
// module chunks = 0